import { VxeUI } from 'vxe-pc-ui';

export const custom = (title, msg, icon) => {
    return VxeUI.modal.alert({
        title,
        content: msg,
        iconStatus: icon,
    });
};

export const info = (title, msg) => {
    return VxeUI.modal.alert({
        title,
        content: msg,
        status: 'info',
    });
};

export const warning = (title, msg) => {
    return VxeUI.modal.alert({
        title,
        content: msg,
        status: 'warning',
    });
};

export const question = (title, msg) => {
    return VxeUI.modal.alert({
        title,
        content: msg,
        status: 'question',
    });
};

export const success = (title, msg) => {
    return VxeUI.modal.alert({
        title,
        content: msg,
        status: 'success',
    });
};

export const error = (title, msg) => {
    return VxeUI.modal.alert({
        title,
        content: msg,
        status: 'error',
    });
};

export const loading = (title, msg) => {
    return VxeUI.modal.alert({
        title,
        content: msg,
        status: 'loading',
    });
};

const alert = (
    title,
    msg,
    options = {
        id: '',
        escClosable: true,
        mask: true,
        lockView: true,
        status: '',
        showClose: true,
        showConfirmButton: false,
    }) => {
    return VxeUI.modal.alert({
        title,
        content: msg,
        ...options,
    });
};

export { alert };

export default alert;
